import { render, staticRenderFns } from "./ExportTags.vue?vue&type=template&id=49cdc312&"
import script from "./ExportTags.vue?vue&type=script&lang=js&"
export * from "./ExportTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports